import {
  CollapseGroup,
  LoadingFit,
  MenuFooter,
  RaytebModal,
} from '../../share/Components'
import PrescriptionHistory from './Items/PrescriptionHistory'
import Medication from './Items/Medication'
import Laboratory from './Items/Laboratory'
import Imaging from './Items/Imaging'
import Physiotherapy from './Items/Physiotherapy'
import Serve from './Items/Serve'
import Referral from './Items/Referral'
import { Button, RaytebForm, TextBox } from '../../share/Elements'
import { PrescriptionViewModel } from '../../models/ViewModels/PrescriptionViewModel'
import useFetch from '../../_services/fetch'
import { RaytebRequests } from '../../_services'
import { useDispatch, useSelector } from 'react-redux'
import { ReducerType } from '../../storeManager/ReducerType'
import { LoginInterface } from '../../Interfaces/LoginInterface'
import { toast } from 'react-toastify'
import {
  addOrUpdatePrescription,
  updateTicketServeRow,
} from '../../storeManager/Reducers/prescriptionSlice'
import { Message } from '../../_services/ResponseErrorType'
import { TextBoxTypeEnum } from '../../enums/TextBoxTypeEnum'
import { useState } from 'react'
import { TicketServeViewModel } from '../../models/ViewModels/TicketServeSaveViewModel'
import HelTag from 'react-helmet'
import { CollapseInterface } from '../../Interfaces/CollapseInterface'
import { ReactElement } from 'react'

function Prescription({
  image,
  medication,
  laboratory,
  physiotherapy,
  ticketServe,
  referral,
  ticketId,
  id,
  shouldPush,
  trackingCode,
  patient,
  isReferenceable,
}: PrescriptionViewModel) {
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const [Opt, setOpt] = useState<boolean>(false)
  const [showDescription, setShowDescription] = useState<boolean>(false)
  const savePrescriptionButtom = (
    <>
      <Button
        onClick={() => {
          if (!trackingCode && isReferenceable) setShowDescription(true)
          else
            reFetch({
              prescriptionId: id!,
            })
        }}
        className={`h-10 w-full  bg-secondary md:mx-auto md:w-96 text-white mx-2 ${shouldPush ? 'animate-pulse' : ''
          }`}
      >
        تجویز نسخه
      </Button>
    </>
  )
  const [buttomElement, setButtomElement] = useState<ReactElement | null>(
    savePrescriptionButtom
  )
  const getTicketServeByPrintCode = useFetch<
    Array<TicketServeViewModel>,
    unknown,
    {
      printCode: string
      prescriptionId: string
    }
  >({
    request: RaytebRequests.TicketServe_TicketServesByPrintCode_GET({
      token: user.token,
    }),
    onSuccess(data) {
      dispatch(updateTicketServeRow(data))
    },
  })
  const dispatch = useDispatch()
  const { isLoading, reFetch } = useFetch<
    PrescriptionViewModel,
    PushPrescriptionInputModel
  >({
    request: RaytebRequests.Prescription_Push_POST({ token: user.token }),
    onSuccess(data) {
      toast.success('نسخه با موفقیت ثبت شد')
      data.shouldPush = false
      dispatch(addOrUpdatePrescription(data))
      setOpt(false)
      setShowDescription(false)
      if (
        data.ticketServe?.rows?.length !== 0 &&
        data.ticketServe?.rows?.some((n) => !n.isDelivered)
      )
        getTicketServeByPrintCode.reFetch(null, {
          prescriptionId: id!,
          printCode: data.trackingCode!,
        })
    },
    onStatusCode201(data) {
      const messages = data.messages as Array<Message>
      messages.forEach((n) => {
        toast[n.flag](n.message)
      })
      setOpt(true)
    },
  })
  const listCollapse: Array<CollapseInterface> = [
    {
      title: 'مشاهده سوابق',
      icon: 'rayteb-history-track',
      className: {
        iconClass: 'text-3xl !text-primary ',
        titleClass: 'text-xs !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 rounded-md',
      },
      isShow: true,
      element: <PrescriptionHistory patientCode={patient?.code!} />,
    },
    {
      title: 'تجویز دارو',
      icon: 'rayteb-capsule',
      className: {
        iconClass: 'text-3xl !text-primary ',
        titleClass: 'text-xs !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 rounded-md',
      },
      isShow: true,
      element: (
        <Medication
          medication={medication!}
          prescriptionId={id!}
          insuranceType={patient?.insuranceType!}
          setButtomPage={setButtomElement}
        />
      ),
    },
    {
      title: 'تجویز آزمایش',
      icon: 'rayteb-medical-laboratory',
      className: {
        iconClass: 'text-3xl !text-primary ',
        titleClass: 'text-xs !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 rounded-md',
      },
      isShow: true,
      element: (
        <Laboratory
          laboratory={laboratory!}
          prescriptionId={id!}
          setButtomPage={setButtomElement}
        />
      ),
    },
    {
      title: 'تجویز تصویربرداری',
      icon: 'rayteb-medical-imaging-root-category',
      className: {
        iconClass: 'text-3xl !text-primary ',
        titleClass: 'text-xs !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 rounded-md',
      },
      isShow: true,
      element: (
        <Imaging
          imaging={image!}
          prescriptionId={id!}
          setButtomPage={setButtomElement}
        />
      ),
    },
    {
      title: 'تجویز فیزیوتراپی',
      icon: 'rayteb-medical-physical-therapy',
      className: {
        iconClass: 'text-3xl !text-primary ',
        titleClass: 'text-xs !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 rounded-md',
      },
      isShow: true,
      element: (
        <Physiotherapy
          physiotherapy={physiotherapy!}
          prescriptionId={id!}
          setButtomPage={setButtomElement}
        />
      ),
    },
    {
      title: 'خدمات پزشکان',
      icon: 'rayteb-serve',
      className: {
        iconClass: 'text-3xl !text-primary ',
        titleClass: 'text-xs !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 rounded-md',
      },
      isShow: true,
      element: (
        <Serve
          ticketServe={ticketServe!}
          ticketId={ticketId!}
          prescriptionId={id!}
          printCode={trackingCode!}
          setButtomPage={setButtomElement}
        />
      ),
    },
    {
      title: 'ارجاع',
      icon: 'rayteb-medical-care-staff-area',
      className: {
        iconClass: 'text-3xl !text-primary ',
        titleClass: 'text-xs !text-primary ',
        className: 'py-3 bg-white border border-primaryDefault2 rounded-md',
      },
      isShow: true,
      element: (
        <Referral
          referral={referral!}
          prescriptionId={id!}
          isReferencable={isReferenceable}
        />
      ),
    },
  ]
  return (
    <>
      <LoadingFit
        isLoading={isLoading}
        fixed={true}
        className='!z-[99999999999999]'
      />
      <div className='pb-20 relative'>
        <HelTag>
          <title>نسخه نویسی</title>
        </HelTag>

        <CollapseGroup
          className='mt-2 pb-24 md:mx-auto md:w-[80%]'
          items={listCollapse}
          onChange={() => setButtomElement(null)}
          removeElementAfterChange={true}
        />

        <MenuFooter>{buttomElement ?? savePrescriptionButtom}</MenuFooter>

        <RaytebModal
          isOpen={Opt}
          className={'relative pt-2'}
          hideModal={() => {
            setOpt(false)
          }}
        >
          <RaytebForm
            className='w-full flex justify-center itmes-center flex-col gap-5 p-5 relative'
            checkIsRequired={true}
            onSubmit={(e) => {
              reFetch({
                prescriptionId: id!,
                optCode: e.currentTarget['OptCode'].value,
              })
            }}
          >
            <TextBox
              Type={TextBoxTypeEnum.Text}
              innerText='کد ارسالی'
              className='w-full'
              name='OptCode'
              isRequired={true}
            />
            <div className='flex justify-between items-center gap-5'>
              <Button
                onClick={() => {
                  setOpt(false)
                }}
                type='button'
                className='!border-2 border-dangerLight !bg-danger !text-white
             !text-xs !w-full h-9 !shadow-lg'
              >
                انصراف
              </Button>
              <Button
                type='submit'
                className='!border-2 border-secondaryLight !bg-secondary !text-white
             !text-xs !w-full h-9 !shadow-lg'
              >
                تایید
              </Button>
            </div>
          </RaytebForm>
        </RaytebModal>

        <RaytebModal
          isOpen={showDescription}
          className={'p-2 relative'}
          hideModal={() => {
            setShowDescription(false)
          }}
          title='بازخورد نسخه ارجاع'
        >
          <RaytebForm
            className='w-full flex justify-center itmes-center flex-col gap-5 p-5 relative'
            checkIsRequired={true}
            onSubmit={(e) => {
              reFetch({
                prescriptionId: id!,
                description: e.currentTarget['description'].value,
              })
            }}
          >
            <TextBox
              Type={TextBoxTypeEnum.Text}
              innerText='توضیحات'
              className='w-full'
              name='description'
              isRequired={true}
            />
            <div className='flex justify-between items-center gap-5'>
              <Button
                onClick={() => {
                  setShowDescription(false)
                }}
                type='button'
                className='!border-2 border-dangerLight !bg-danger !text-white
             !text-xs !w-full h-9 !shadow-lg'
              >
                انصراف
              </Button>
              <Button
                type='submit'
                className='!border-2 border-secondaryLight !bg-secondary !text-white
             !text-xs !w-full h-9 !shadow-lg'
              >
                تایید
              </Button>
            </div>
          </RaytebForm>
        </RaytebModal>
      </div>
    </>
  )
}

export default Prescription
